import Crypto from "gurhan/helpers/Crypto";
const crypto = new Crypto("REZZERVATION_2022");

export default crypto;
